(() => {
  const english = document.documentElement.lang.toLowerCase().startsWith('en');
  const replacements = english ? [
    ['A partir de ', 'From '],
    [', o envio é grátis!', ', delivery to mainland Portugal is free!'],
    ['Complete com mais ', 'Add '],
    [' e ganhe envio grátis!', ' more for free delivery to mainland Portugal!'],
    ['Parabéns! Tens envio grátis 🎉', 'You qualify for free delivery to mainland Portugal 🎉']
  ] : [
    [', o envio é grátis!', ', o envio para Portugal Continental é grátis!'],
    ['Complete com mais ', 'Faltam '],
    [' e ganhe envio grátis!', ' para teres envio grátis em Portugal Continental!'],
    ['Parabéns! Tens envio grátis 🎉', 'Tens envio grátis em Portugal Continental 🎉']
  ];
  const translate = text => replacements.reduce((value, pair) => value.replaceAll(pair[0], pair[1]), text);
  const update = () => {
    // Keep Hextom's live amount, currency formatting and cart calculations intact.
    document.querySelectorAll('#fsb_bar, [role="status"]').forEach(root => {
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        const translated = translate(node.nodeValue);
        if (translated !== node.nodeValue) node.nodeValue = translated;
      }
    });
    document.querySelectorAll('[aria-label*="envio"]').forEach(element => {
      const original = element.getAttribute('aria-label');
      const translated = translate(original);
      if (translated !== original) element.setAttribute('aria-label', translated);
    });
  };
  new MutationObserver(update).observe(document.body, {
    subtree: true, childList: true, characterData: true,
    attributes: true, attributeFilter: ['aria-label']
  });
  update();
})();
